module.exports = __webpack_public_path__ + "img/stock5.e318e2ba.png";